// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2tP9e","row":"Node_row__1mlc2","label":"Node_label__1K8gT","footer":"Node_footer__oMbux"};